module.exports = __webpack_public_path__ + "img/slovakia.7489cb14.svg";